var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoProf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9449 25.168C19.4901 25.168 24.796 19.7731 24.796 13.1182C24.796 6.46325 19.4901 1.06836 12.9449 1.06836C6.39969 1.06836 1.09375 6.46325 1.09375 13.1182C1.09375 19.7731 6.39969 25.168 12.9449 25.168Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44238 9.39134C9.44238 8.40151 9.82911 7.45225 10.5175 6.75234C11.2059 6.05243 12.1395 5.65918 13.113 5.65918C14.0865 5.65918 15.0201 6.05243 15.7085 6.75234C16.3969 7.45225 16.7836 8.40151 16.7836 9.39134C16.7836 11.4523 15.14 13.6984 13.113 13.6984C11.086 13.6984 9.44238 11.4474 9.44238 9.39134Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 22.3612C19.7446 19.6668 16.6681 17.104 12.9448 17.104C9.2215 17.104 6.1403 19.6668 5.6084 22.3612",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProf);
export default __webpack_public_path__ + "static/media/logoProf.2f3443267ba9cf2b509ee227ea023941.svg";
export { ForwardRef as ReactComponent };